import Vue from 'vue'
import App from '@/App.vue'
import ViewUI from 'view-design'
import './assets/css/theme.less'
import router from '@/router/index'
import store from '@/store/'
import '@/assets/css/main.styl'
import plugins from './plugins/index'
import globalComponent from './global-components'
import preData from './assets/js/preData'
import Wser from './ws'
import envConst from '@/const.js'
//tdesign-vue
import TDesign from 'tdesign-vue';
import 'tdesign-vue/es/style/index.css';
import './assets/css/tThemeOverwrite.less'
Vue.use(TDesign);


//umy-ui
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css'// 引入样式
Vue.use(UmyUi)


import VueAMap from 'vue-amap'  //引入
Vue.use(VueAMap)				//全局注册
VueAMap.initAMapApiLoader({ 	//初始化
  key: '25201ee97d156fc6a47b35ebe519387e',		//高德地图api开放平台申请的key
  //需要用到的插件 用什么放什么 放多余的加载会很慢
  plugin: ['AMap.ToolBar'],
  v: '1.4.4'	//版本号
})


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  navbar: true, //底部缩略图
  toolbar: true, //底部工具栏
  button: true, //右上角按钮
  title: false, //当前图片标题
  movable: false, //是否可以移动
  zoomable: true, //是否可以缩放
  transition: true //使用 CSS3 过度
})


Vue.use(plugins)
Vue.use(ViewUI)
Vue.use(globalComponent)
Vue.config.productionTip = false
Vue.prototype.$preData = preData
Vue.prototype.$envConst = envConst

import dayjs from 'dayjs'
//校验前导出时间间隔
Vue.prototype.$exportCheckout = (params, startKey, endKey, dayNum = 90) => {
  let startDate = params[startKey]
  let endDate = params[endKey]
  // 默认30天
  var start = new Date(startDate); //开始的时间
  var end = new Date(endDate); //结束的时间
  var se = end - start; //计算两个时间之间的秒数
  var days = Math.floor(se / (24 * 3600 * 1000)); // 计算天数
  if (isNaN(days)) {
    // ViewUI.Message.warning({
    //   content: `请选择开始和结束时间`
    // })
    const date = new Date()
    params[endKey] = dayjs(date).format('YYYY-MM-DD')
    date.setMonth(date.getMonth() - 3)
    params[startKey] = dayjs(date).format('YYYY-MM-DD')
    return true
  } else if (days > dayNum) {
    if (dayNum == 365) {
      ViewUI.Message.warning({
        content: `查询时间不能大于一年`
      })
    } else {
      ViewUI.Message.warning({
        content: `导出时间不能大于${dayNum}天`
      })
    }
    return false
  } else {
    return true
  }
}
//按钮权限
Vue.prototype.$showButton = (id) => {
  if(store.buttons && store.buttons.length>0){
    for(var i=0;i<store.buttons.length;i++){
      if(store.buttons[i].id == id){
        if(store.buttons[i].state==1){
          return true;
        }else{
          return false;
        }
      }
    }
    return false;
  }else{
    return true;
  }
}
//导出文件
Vue.prototype.$exportFile = (res) => {
  if (res.data.size == 38) {
    console.log(res.data.size)
    return false
    // return ViewUI.Message.info({
    //   content: '文件正在生成中,稍后可在 系统管理/文件下载 查看'
    // })
  }
  const elink = document.createElement('a')
  if (res.headers['content-disposition']) {
    elink.download = decodeURI(
      res.headers['content-disposition'].split(';')[1].slice(11, -1)
    )
  } else {
    elink.download = res.headers.date + '.xlsx'
  }
  elink.href = URL.createObjectURL(res.data)
  elink.click()
  URL.revokeObjectURL(elink.href)
}
//导出文件/自定义文件名
Vue.prototype.$exportFileName = () => {
  return new Promise((resolve, reject) => {
    //自定义文件名称
    var filename = ''
    ViewUI.Modal.confirm({
      title: '请输入文件名称',
      render: (h) => {
        return h('Input', {
          props: {
            autofocus: true,
            placeholder: '请输入自定义文件名称(留空为默认)',
          },
          on: {
            'on-change': (event) => {
              filename = event.target.value
            },
          }
        })
      },
      onOk() {
        resolve(filename)
      },
      onCancel() {
        reject('取消导出')
      }
    })
  })
}


const wser = new Wser()
Vue.prototype.$wser = wser
function init() {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}
if (localStorage.token && localStorage.userInfo) {
  preData(wser).then(() => {
    init()
  })
} else {
  init()
}
// 页面关闭时下线IM
window.onbeforeunload = function () {
  if (store.state.userInfo.type === 20) {
    store.state.im.instance.logout()
    const formData = new FormData()
    formData.append('Authorization', localStorage.token)
    navigator.sendBeacon(`${envConst.API_ORIGIN}/im/offline`, formData)
  }
}
